// Lightbox of the images and videos (GLightbox, MIT): links with data-lightbox, grouped by data-gallery, the caption in
// data-description, the steps of the image in data-srcset / data-sizes (see components/media/figure.html.twig).
// Videos of the media library play with Plyr, bundled here: GLightbox only fetches Plyr (script and stylesheet) from its CDN
// when window.Plyr is missing, so nothing is loaded from a third party. YouTube/Vimeo links with the two-click player use
// their own lightbox (init/initVideoConsent.js).
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
// the icon sprite of Plyr, else it is fetched from cdn.plyr.io
import plyrIcons from 'plyr-icons';
import '../scss/vendor/lightbox.scss';

window.Plyr = Plyr;

// language of the page (de when the attribute is missing), other languages get the English label
const moreTexts = { de: 'Mehr anzeigen', en: 'See more', nl: 'Meer weergeven' };
const moreText = moreTexts[(document.documentElement.lang || 'de').slice(0, 2)] ?? moreTexts.en;

// shared with the two-click player, so both lightboxes look and behave the same
export const lightboxOptions = {
    touchNavigation: true,
    keyboardNavigation: true,
    loop: false,
    zoomable: true,
    openEffect: 'zoom',
    closeEffect: 'zoom',
    slideEffect: 'slide',
    descPosition: 'bottom',
    moreText,
    moreLength: 0,
    plyr: {
        config: {
            ratio: '16:9',
            iconUrl: plyrIcons,
            fullscreen: { enabled: true, iosNative: true },
            youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3 },
            vimeo: { byline: false, portrait: false, title: false, dnt: true },
        },
    },
};

export default function initLightbox() {
    // data-fancybox: links of templates that are not moved yet (they open as single slides)
    return GLightbox({ ...lightboxOptions, selector: 'a[data-lightbox], a[data-fancybox]' });
}
